import React, { Fragment } from "react";

import "./Team.css";
import ethanPic from "../public/ethan2-800w.png";
import sethPic from "../public/IMG_2214.JPG";

const Team = () => {
  return (
    <div className="thq-section-padding">
      <div className="team-max-width thq-section-max-width">
        <div className="team-section-title">
          <div className="team-content1">
            <h2 className="thq-heading-2">
              <Fragment>
                <span className="team-text19">Meet Our Team</span>
              </Fragment>
            </h2>
          </div>
        </div>
        <div className="team-content2">
          <div className="team-content3">
            <div className="team-row">
              <div className="team-card1">
                <img
                  src={ethanPic}
                  alt="Ethan Friman"
                  className="thq-img-ratio-1-1 team-member-image1"
                />
                <div className="team-content4">
                  <div className="team-title1">
                    <span className="team-text11 thq-body-small">
                      <Fragment>
                        <span className="team-text18">Ethan Friman</span>
                      </Fragment>
                    </span>
                    <span className="thq-body-small">
                      <Fragment>
                        <span className="team-text17">
                          Co-Founder &amp; CEO
                        </span>
                      </Fragment>
                    </span>
                  </div>
                  <span className="team-text13 thq-body-small">
                    <Fragment>
                      <span className="team-text23">
                        Ethan Friman is the co-founder of Coin Basis and a
                        cryptocurrency enthusiast with over seven years of
                        experience in the field. He earned his Bachelor of
                        Science in Information Systems, and Management from the
                        University of Illinois Urbana-Champaign. His career
                        includes working with crypto startups, where he
                        developed a deep understanding of blockchain technology
                        and its potential to transform industries. Passionate
                        about simplifying complex processes, Ethan envisioned
                        Coin Basis as a tool to make cryptocurrency cost basis
                        calculations accessible and affordable for everyone. His
                        firsthand experience navigating the challenges of crypto
                        tax preparation inspired him to create a solution that
                        empowers users to take control of their financial
                        reporting.
                      </span>
                    </Fragment>
                  </span>
                </div>
                <div className="team-social-icons1">
                  <a
                    href="https://www.linkedin.com/in/ethan-friman"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="team-link1"
                  >
                    <svg
                      viewBox="0 0 877.7142857142857 1024"
                      className="team-icon1 thq-icon-small"
                    >
                      <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                    </svg>
                  </a>
                </div>
              </div>
              <div className="team-card2">
                <img
                  src={sethPic}
                  alt="Seth Friman"
                  className="thq-img-ratio-1-1 team-member-image2"
                />
                <div className="team-content5">
                  <div className="team-title2">
                    <span className="team-text14 thq-body-small">
                      <Fragment>
                        <span className="team-text22">Seth Friman</span>
                      </Fragment>
                    </span>
                    <span className="thq-body-small">
                      <Fragment>
                        <span className="team-text21">
                          Co-Founder &amp; CTO
                        </span>
                      </Fragment>
                    </span>
                  </div>
                  <span className="team-text16 thq-body-small">
                    <Fragment>
                      <span className="team-text20">
                        Seth Friman is the co-founder of Coin Basis and an
                        accomplished software developer with a strong background
                        in data science and economics. He holds a Bachelor of
                        Science in Computer Science and Economics from
                        Northeastern University in Boston. Known for his
                        analytical mind and innovative approach to
                        problem-solving, Seth brings a passion for building
                        tools that are both practical and user-centric. At Coin
                        Basis, Seth spearheaded the development of the
                        platform&apos;s algorithm and user interface, ensuring
                        the software delivers accurate, seamless, and intuitive
                        cost basis calculations for cryptocurrency users. His
                        dedication to creating impactful products is at the core
                        of Coin Basis&apos;s mission to simplify crypto tax
                        preparation.
                      </span>
                    </Fragment>
                  </span>
                </div>
                <div className="team-social-icons2">
                  <a
                    href="https://www.linkedin.com/in/sethfriman/"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="team-link2"
                  >
                    <svg
                      viewBox="0 0 877.7142857142857 1024"
                      className="team-icon3 thq-icon-small"
                    >
                      <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="team-content6">
            <div className="team-content7"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
